function isNative() {
  const platformEnv = process.env.PLATFORM_ENV;

  if (!platformEnv || platformEnv !== "web") {
    return true;
  }

  return false;
}

module.exports = isNative;
